import { render, staticRenderFns } from "./TkButton.vue?vue&type=template&id=6f63a02c&"
import script from "./TkButton.vue?vue&type=script&lang=js&"
export * from "./TkButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports